import { CSSProperties } from 'react';

export const drawerBodyStyles = {
    display: 'flex',
    flexDirection: 'column',
} as CSSProperties;
